import { z } from "zod";

export const envSchema = z.object({
	VITE_APP_NAME: z.string().default("Open Booking"),
	VITE_APP_SLUG: z.string().default("open-booking"),
	VITE_SERVER_URL: z.url().default("http://localhost:8787"),
});

const _env = envSchema.parse(import.meta.env);

export const env = {
	MODE: import.meta.env.MODE,
	APP_NAME: _env.VITE_APP_NAME,
	APP_SLUG: _env.VITE_APP_SLUG,
	SERVER_URL: _env.VITE_SERVER_URL,
} as const;
